import { SuburbanAreaDailyrentContainer } from '../../containers/advancedFilters/SuburbanAreaDailyrentContainer';
import { IFilter } from '../../types/advancedFilters';

export const suburbanAreaDailyrent: IFilter = {
  component: SuburbanAreaDailyrentContainer,
};
